
      var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 29,
  width: 26,
  height: 16,
  rx: 1,
  transform: "rotate(-90 8 29)",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 24.5,
  r: 1.5,
  transform: "rotate(-180 16 24.5)",
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.22 8.946c-.03.073-.046.143-.086.192a2.31 2.31 0 0 1-.298.314c-.321.264-.65.517-.975.776-.264.21-.53.419-.755.672-.088.1-.17.207-.243.317-.084.126-.087.26-.026.404.14.338.314.659.492.978.491.881.966 1.771 1.404 2.68.081.17.137.35.203.527.007.018.01.038.012.057.008.096-.035.152-.128.133a.976.976 0 0 1-.296-.102c-.22-.127-.436-.264-.648-.404-.687-.452-1.372-.908-2.058-1.361a5.283 5.283 0 0 0-.872-.482 1.53 1.53 0 0 0-.731-.13c-.194.018-.373.081-.547.165a5.297 5.297 0 0 0-.867.56c-.55.415-1.097.837-1.646 1.253-.119.09-.244.171-.369.253a.751.751 0 0 1-.156.079c-.085.03-.143-.015-.13-.104a.965.965 0 0 1 .06-.215c.145-.368.288-.738.442-1.104.246-.586.503-1.168.751-1.753a3.44 3.44 0 0 0 .211-.649c.054-.261-.019-.468-.24-.614-.124-.082-.256-.15-.385-.224-.092-.052-.187-.1-.278-.152-.05-.03-.1-.062-.147-.098-.147-.114-.139-.252.03-.328.191-.088.388-.165.586-.235.306-.108.616-.203.923-.308.115-.038.226-.088.338-.133.29-.116.518-.311.685-.571.164-.258.309-.528.466-.79.075-.125.15-.25.24-.363a.574.574 0 0 1 .204-.152c.143-.066.246-.036.34.09.062.081.113.17.165.258.097.162.188.327.287.487.09.143.221.235.386.266.107.02.219.036.326.025.342-.033.683-.075 1.023-.124.533-.076 1.065-.164 1.599-.238.145-.02.296-.012.444-.007.06.002.125.022.178.05.036.02.057.068.087.105Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\r\n  <rect x=\"8\" y=\"29\" width=\"26\" height=\"16\" rx=\"1\" transform=\"rotate(-90 8 29)\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <circle cx=\"16\" cy=\"24.5\" r=\"1.5\" transform=\"rotate(-180 16 24.5)\" fill=\"black\"/>\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.2207 8.94645C20.1892 9.01858 20.1744 9.08882 20.134 9.13758C20.0418 9.2487 19.9465 9.36086 19.8357 9.45209C19.515 9.71615 19.1854 9.96929 18.8606 10.2284C18.597 10.4386 18.3309 10.6468 18.1059 10.9004C18.0178 10.9997 17.9365 11.1066 17.8629 11.2173C17.779 11.3433 17.7765 11.4767 17.8365 11.6209C17.9774 11.9591 18.1511 12.2798 18.3288 12.5987C18.82 13.4802 19.2954 14.3701 19.7331 15.2799C19.8142 15.4486 19.8696 15.6299 19.9362 15.8058C19.9431 15.8239 19.9468 15.8438 19.9484 15.8633C19.9564 15.9594 19.9127 16.0148 19.8197 15.9965C19.7179 15.9765 19.6132 15.9451 19.5238 15.8937C19.3033 15.7671 19.0883 15.6303 18.8759 15.4903C18.1889 15.038 17.5045 14.582 16.8183 14.1286C16.5403 13.9449 16.2542 13.7755 15.9461 13.6469C15.712 13.5491 15.4704 13.4953 15.2148 13.5176C15.0209 13.5346 14.8416 13.598 14.6682 13.682C14.3566 13.8331 14.0762 14.0343 13.801 14.2419C13.2504 14.6574 12.7044 15.0789 12.1546 15.4954C12.0361 15.5852 11.9108 15.6662 11.7864 15.7476C11.7376 15.7795 11.6844 15.8073 11.6297 15.8268C11.545 15.8569 11.4872 15.8124 11.5 15.723C11.5104 15.6501 11.5324 15.5772 11.5595 15.5084C11.7047 15.1395 11.8479 14.7696 12.0017 14.4043C12.2485 13.8182 12.5054 13.2363 12.7534 12.6507C12.8421 12.4412 12.9178 12.2269 12.964 12.002C13.0178 11.7407 12.9453 11.534 12.7239 11.3881C12.6 11.3064 12.4681 11.2371 12.3388 11.1639C12.2469 11.1118 12.1525 11.0642 12.0609 11.0116C12.0101 10.9825 11.9605 10.9502 11.9142 10.9143C11.7668 10.8002 11.775 10.6625 11.9436 10.5856C12.1351 10.4982 12.3319 10.4206 12.5305 10.3508C12.8363 10.2433 13.1463 10.1479 13.4532 10.0435C13.5676 10.0046 13.6786 9.95513 13.791 9.91007C14.0804 9.79407 14.3089 9.599 14.4756 9.33893C14.6405 9.08145 14.7849 8.81075 14.9422 8.54819C15.0167 8.42386 15.0925 8.29873 15.1829 8.18622C15.2345 8.12186 15.3106 8.06912 15.3861 8.03418C15.5293 7.96802 15.632 7.99788 15.7269 8.12396C15.788 8.20511 15.8388 8.29445 15.8912 8.38194C15.9878 8.5436 16.0793 8.70856 16.1784 8.86863C16.2675 9.0123 16.3991 9.10408 16.564 9.13459C16.6709 9.15438 16.7829 9.17088 16.8898 9.16036C17.2316 9.12661 17.5729 9.08499 17.913 9.03643C18.4463 8.96026 18.9779 8.87177 19.5115 8.79784C19.6575 8.77765 19.8083 8.78583 19.9565 8.79101C20.0167 8.79316 20.0805 8.8133 20.1341 8.84166C20.17 8.86066 20.1909 8.90856 20.2207 8.94645Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/phone.00150308b9556210d06988404215de68.svg"),
        {
          React: SvgPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      